import React from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";

// Components
import ReviewDocItem from "./ReviewDocItem";

// Make the wrapped element sortable
const SortableItem = SortableElement(ReviewDocItem);

export default SortableContainer(props => {
	const { files, review } = props;

	return (
		<div className="group-document-container">
			{files.map((file, i) => (
				<SortableItem
					key={`file-${i}`}
					index={i}
					file={file}
					review={review}
					i={i}
					{...props}
				/>
			))}
		</div>
	);
});



// WEBPACK FOOTER //
// ./src/components/admin/reviews/form-components/SortableDocumentList.js